import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Typography } from '@mui/material';
import { Box } from '@mui/material';
import { getIntegrationAppLabel } from 'helpers';
import { IntegrationApp, useIntegration_CreateIntegrationMutation } from 'queries';

import Spinner from 'common/spinner';

import { useStyles } from './auth-result-page.styles';

export const AuthResultPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const { search } = useLocation();

  const [authStatus, setAuthStatus] = useState<'success' | 'failure'>('failure');
  const [description, setDescription] = useState<string>('');

  const [createIntegration, { loading: createIntegrationExecuting }] =
    useIntegration_CreateIntegrationMutation({
      onCompleted: () => {
        setAuthStatus('success');
      },
      onError: (e) => {
        setDescription(e.message);
        setAuthStatus('failure');
      },
    });

  const queryParams = new URLSearchParams(search);
  const app = queryParams.get('app');
  const portalId = queryParams.get('state');
  const code = queryParams.get('code');

  useEffect(() => {
    if (app && code && portalId) {
      createIntegration({
        variables: {
          input: {
            portalId: portalId,
            app: app as IntegrationApp,
            oAuthCode: code,
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [app, code, portalId]);

  if (createIntegrationExecuting) {
    return <Spinner />;
  }

  return (
    <Box>
      <div className={classes.parentContainer}>
        <img src={'/logo-light-stacked.svg'} alt="Trustate Logo" className={classes.logo} />
        <img src={'/lock.svg'} alt="Trustate Lock" className={classes.lock} />
        {authStatus === 'failure' ? (
          <Box>
            <Typography className={classes.title}>Uh-oh!</Typography>
            <Typography className={classes.subtitle}>
              There was an issue authenticating with {getIntegrationAppLabel(app)}!
            </Typography>
            <Typography>
              {description || 'Please try again or contact support if the issue persists.'}
            </Typography>
          </Box>
        ) : (
          <Box>
            <Typography className={classes.title}>Success!</Typography>
            <Typography className={classes.subtitle}>
              You've successfully authenticated with {getIntegrationAppLabel(app)}!
            </Typography>
          </Box>
        )}
        <Button className={classes.button} fullWidth onClick={() => history.replace('/')}>
          Home
        </Button>
      </div>
    </Box>
  );
};
